import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { makeCutoffOrZscoreIntersectionValidator } from 'utilities/validators';

import CutoffsFieldsComponent from './Component';

import getDistributionFunctionsByType from 'calculators/distributions';
import { setCutoffs } from 'store/scenes/distributions/cutoffs/actions';
import { getCutoffs } from 'store/scenes/distributions/cutoffs/selectors';

import {
  setAlpha,
  setLeftCutoff, setRightCutoff,
  setLeftZScore, setRightZScore
} from 'store/form/distributions/actions';

import {
  getTailType, isLeftTailSelected, isRightTailSelected
} from 'store/scenes/distributions/chart/selectors';

import {
  getDistributionsType,
  getDistributionsFormValues
} from 'store/form/distributions/selectors';

import { round5 } from 'utilities/math';

class CutoffsFieldsContainer extends React.PureComponent {

    validateLeftCutoffFn = (value, allValues = { rightCutoff: this.props.rightCutoffX }) => {
      const intersectValidator = makeCutoffOrZscoreIntersectionValidator(
        +value,
        +allValues.rightCutoff,
        this.props.tailType
      );

      return intersectValidator;
    };

    validateRightCutoffFn = (value, allValues = { leftCutoff: this.props.leftCutoffX }) => {
      const intersectValidator = makeCutoffOrZscoreIntersectionValidator(
        +allValues.leftCutoff,
        +value,
        this.props.tailType
      );

      return intersectValidator;
    };

    handleLeftCutoffChange = (_, newLeftCutoff) => {
      this.props.recalculateAlphaAndCutoffs({
        type: 'left', value: newLeftCutoff
      });
    };

    handleRightCutoffChange = (_, newRightCutoff) => {
      this.props.recalculateAlphaAndCutoffs({
        type: 'right', value: newRightCutoff
      });
    };

    render () {
      return (
        <CutoffsFieldsComponent
          leftCutoffNormalizeFn={this.leftCutoffNormalizeFn}
          rightCutoffNormalizeFn={this.rightCutoffNormalizeFn}

          isLeftCutoffFieldVisible={this.props.isLeftCutoffFieldVisible}
          isRightCutoffFieldVisible={this.props.isRightCutoffFieldVisible}
          isCenterCutoffChosen={this.props.isCenterCutoffChosen}

          onLeftCutoffChange={this.handleLeftCutoffChange}
          onRightCutoffChange={this.handleRightCutoffChange}

          validateLeftCutoffFn={this.validateLeftCutoffFn}
          validateRightCutoffFn={this.validateRightCutoffFn}
        />
      );
    }
}

CutoffsFieldsContainer.propTypes = {
  isLeftCutoffFieldVisible: PropTypes.bool.isRequired,
  isRightCutoffFieldVisible: PropTypes.bool.isRequired,
  isCenterCutoffChosen: PropTypes.bool.isRequired,

  recalculateAlphaAndCutoffs: PropTypes.func.isRequired,

  rightCutoffX: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  leftCutoffX: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  tailType: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  isLeftCutoffFieldVisible: isLeftTailSelected(state),
  isRightCutoffFieldVisible: isRightTailSelected(state),
  isCenterCutoffChosen: getTailType(state) === 'center',

  rightCutoffX: getCutoffs(state) && getCutoffs(state).right.x,
  leftCutoffX: getCutoffs(state) && getCutoffs(state).left.x,

  tailType: getTailType(state)
});

const mapDispatchToProps = {
  recalculateAlphaAndCutoffs: cutoff => (dispatch, getState) => {
    const state = getState();
    const tailType = getTailType(state);
    const type = getDistributionsType(state);
    const fns = getDistributionFunctionsByType(type);
    const distributionFormValues = getDistributionsFormValues(state);

    let leftCutoffX = null;
    let rightCutoffX = null;
    if (cutoff.type === 'left') {
      leftCutoffX = cutoff.value;
      rightCutoffX = getCutoffs(state) && getCutoffs(state).right.x;
    } else {
      rightCutoffX = cutoff.value;
      leftCutoffX = getCutoffs(state) && getCutoffs(state).left.x;
    }

    const alpha = fns.getAlphaByCutoffsAndTailType(distributionFormValues, leftCutoffX, rightCutoffX, tailType);
    const cutoffs = fns.getCutoffsByCutoffXValues(distributionFormValues, leftCutoffX, rightCutoffX);

    let zScoreLeft = -1;
    let zScoreRight = 1;
    // z score is available only for the normal distribution
    if (type === 'normal') {
      zScoreLeft = fns.getZScoreByCutoffValue(distributionFormValues, leftCutoffX);
      zScoreRight = fns.getZScoreByCutoffValue(distributionFormValues, rightCutoffX);
    }

    // recalculates Alpha to account for rounding errors
    // eslint-disable-next-line
    // TODO: find a better way of doing this
    const recalculateAlpha = () => {
      if (round5(alpha) >= 1) {
        return 1;
      }
      if (round5(alpha) <= 0) {
        return 0;
      }
      return round5(alpha);
    };

    dispatch([
      setAlpha(
        recalculateAlpha()
      ),

      setCutoffs(cutoffs),

      setLeftCutoff(leftCutoffX),
      setRightCutoff(rightCutoffX),

      setLeftZScore(zScoreLeft),
      setRightZScore(zScoreRight)
    ]);
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(
  CutoffsFieldsContainer
);
